// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function makeOption(label, groupName, swatch, disabledOpt, hiddenOpt, id, alt, value) {
  var disabled = disabledOpt !== undefined ? disabledOpt : true;
  var hidden = hiddenOpt !== undefined ? hiddenOpt : false;
  return {
    id: id,
    groupName: groupName,
    label: label,
    value: value,
    alt: alt,
    swatch: Belt_Option.getWithDefault(swatch, /* NoSwatch */0),
    disabled: disabled,
    hidden: hidden
  };
}
export { makeOption };
/* No side effect */